(function () {
  'use strict';

  function initBundlePicker() {
    const pickers = document.querySelectorAll('.bundle-picker');
    pickers.forEach(picker => setupPicker(picker));
  }

  function setupPicker(picker) {
    const options = picker.querySelectorAll('.bundle-picker__option');
    const ctaBtn = picker.querySelector('.bundle-picker__cta');

    const firstOption = picker.querySelector('.bundle-picker__option.is-selected');
    if (firstOption) {
      initColorSelects(firstOption);
      firstOption.dataset.colorInitialized = 'true';
    }

    options.forEach(option => {
      option.addEventListener('click', () => {
        if (option.classList.contains('is-selected')) return;

        options.forEach(o => {
          o.classList.remove('is-selected');
          const variants = o.querySelector('.bundle-picker__variants');
          if (variants) variants.style.display = 'none';
        });

        option.classList.add('is-selected');

        const variants = option.querySelector('.bundle-picker__variants');
        if (variants) {
          variants.style.display = 'block';
          if (!option.dataset.colorInitialized) {
            initColorSelects(option);
            option.dataset.colorInitialized = 'true';
          }
        }

        const radio = option.querySelector('input[type="radio"]');
        if (radio) radio.checked = true;
      });
    });

    if (ctaBtn) {
      ctaBtn.addEventListener('click', () => handleAddToCart(picker, ctaBtn));
    }
  }

  function initColorSelects(container) {
    const selects = container.querySelectorAll('.color-select');
    selects.forEach(select => setupColorSelect(select));
  }

  function setupColorSelect(select) {
    const trigger = select.querySelector('.color-select__trigger');
    const dropdown = select.querySelector('.color-select__dropdown');
    const hiddenInput = select.querySelector('.color-select__value');
    const options = select.querySelectorAll('.color-select__option');

    if (!trigger || !dropdown) return;

    // 确保初始状态正确
    dropdown.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');

    const firstAvailable = select.querySelector('.color-select__option:not([data-disabled="true"])');
    if (firstAvailable) {
      applySelection(firstAvailable, trigger, hiddenInput, select);
      firstAvailable.classList.add('is-selected');
    }

    trigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      closeAllDropdowns();
      if (!isOpen) {
        dropdown.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    options.forEach(option => {
      if (option.dataset.disabled === 'true') return;
      option.addEventListener('click', (e) => {
        e.stopPropagation();
        options.forEach(o => o.classList.remove('is-selected'));
        option.classList.add('is-selected');
        applySelection(option, trigger, hiddenInput, select);
        dropdown.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function applySelection(option, trigger, hiddenInput, select) {
    const colorClass = option.dataset.colorClass;
    const label = option.dataset.label;
    const variantId = option.dataset.variantId;
    const image = option.dataset.image;

    const dot = trigger.querySelector('.color-select__dot');
    if (dot) dot.className = 'color-select__dot ' + colorClass;

    const labelEl = trigger.querySelector('.color-select__label');
    if (labelEl) labelEl.textContent = label;

    if (hiddenInput) hiddenInput.value = variantId;

    const masterInput = document.querySelector('input[data-js-bundle-variant-id]');
    if (masterInput && variantId) masterInput.value = variantId;

    if (image && image !== 'null') {
      const row = select.closest('.bundle-picker__variant-row');
      const thumb = row?.querySelector('.bundle-picker__variant-thumb');
      if (thumb) thumb.src = image;
    }
  }

  function closeAllDropdowns() {
    document.querySelectorAll('.color-select__dropdown').forEach(d => { d.hidden = true; });
    document.querySelectorAll('.color-select__trigger').forEach(t => { t.setAttribute('aria-expanded', 'false'); });
  }

  document.addEventListener('click', closeAllDropdowns);

  // bfcache 恢复时只重置按钮，不重新初始化
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      document.querySelectorAll('.bundle-picker__cta').forEach(btn => {
        btn.disabled = false;
        btn.textContent = 'Add to Cart';
      });
    }
  });

  async function handleAddToCart(picker, btn) {
    const selected = picker.querySelector('.bundle-picker__option.is-selected');
    if (!selected) return;

    const inputs = selected.querySelectorAll('.color-select__value');
    if (!inputs.length) return;

    const discount = parseInt(selected.dataset.discount) || 0;

    const items = Array.from(inputs)
      .filter(input => input.value && !isNaN(parseInt(input.value)))
      .map(input => ({
        id: parseInt(input.value),
        quantity: 1
      }));

    if (!items.length) {
      alert('Please select a color first.');
      return;
    }

    btn.disabled = true;
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });

      if (!res.ok) throw new Error('Cart error');

      if (discount === 10) {
        window.location.href = '/checkout?discount=BUNDLE10';
      } else if (discount === 15) {
        window.location.href = '/checkout?discount=BUNDLE15';
      } else {
        window.location.href = '/cart';
      }

    } catch (err) {
      console.error('Bundle add to cart failed:', err);
      btn.disabled = false;
      btn.textContent = originalText;
      alert('Something went wrong. Please try again.');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBundlePicker);
  } else {
    initBundlePicker();
  }

})();
